import { DataMutationFunction } from 'network/models';
import { httpClient } from 'network';

export const mutationWebinarForm: DataMutationFunction = variables => {
  const { body } = variables || {};

  return httpClient.post('/webinar/submit', body);
};
